import {create} from "zustand";

const ZustandAlert = create((set) => ({
  success: false,
  invalid: false,
  simulated: false,

  triggerSuccess: () => {
    set({ success: true });
    setTimeout(() => set({ success: false }), 5000);
  },

  triggerInvalid: () => {
    set({ invalid: true });
    setTimeout(() => set({ invalid: false }), 5000);
  },

  triggerSimulated: () => {
    set({ simulated: true });
    setTimeout(() => set({ simulated: false }), 5000);
  },
}));

export default ZustandAlert;
